module.exports = __webpack_public_path__ + "static/media/jj-banner.c692c6ad.png";